import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import BannerTitle from '../layouts/about/banner/BannerTitle'
import {Header, Footer, BottomBar} from '../layouts/general/index'
import { TabProjectAcondicionamiento } from '../layouts/home01';

class ProjectsAcondicionamiento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    logoweb: "assets/img/logo_aljosi_x2.png",
                    names: "Proyectos",
                }
            ],
            banners: [
                {
                    id: 1,
                    links: '',
                    titlelink: '',
                    border: '',
                    name: 'Proyectos | Acondicionamiento',
                    heading: 'Acondicionamiento'
                }
            ]
        }
    }
    render() {
        return (
            <div className="header-fixed page no-sidebar header-style-2 topbar-style-1 menu-has-search">
                <div id="wrapper" className="animsition">
                    <div id="page" className="clearfix">
                        <div id="site-header-wrap">
                            {/* <TopBar /> */}
                            {
                                this.state.headers.map((data,idx) =>(
                                    <Header data={data} key={idx}/>
                                ))
                            }
                        </div>
                        {
                            this.state.banners.map(data =>(
                                <BannerTitle key={data.id} data={data}/>
                            ))
                        }
                        <div id="main-content" className="site-main clearfix">
                            <div id="content-wrap">
                                <div id="site-content" className="site-content clearfix">
                                    <div id="inner-content" className="inner-content-wrap">
                                        <div className="page-content">
                                            <div className="row-services">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="themesflat-spacer clearfix" data-desktop={73} data-mobile={60} data-smobile={60} />
                                                        <ul className="themesflat-filter style-1 clearfix">
                                                            <li className="active"><Link to="#" data-filter="*">TODOS LOS PROYECTOS</Link></li>
                                                            <li><Link to="#" data-filter=".integral">PROYECTOS INTEGRALES</Link></li>
                                                            <li><Link to="#" data-filter=".acondicionamiento">OBRAS DE ACONDICIONAMIENTO</Link></li>
                                                            <li><Link to="#" data-filter=".ampliaciones">REMODELACIONES</Link></li>
                                                            {/* <li><Link to="#" data-filter=".residenciales">RESIDENCIALES</Link></li>
                                                            <li><Link to="#" data-filter=".institucionales">INSTITUCIONALES</Link></li>  */}
                                                        </ul>
                                                        <div className="elm-button">
                                                            <Link to="/services" onClick={() => {window.location.href="/services"}} className="themesflat-button bg-white">REGRESAR</Link>
                                                        </div>
                                                        <div className="themesflat-spacer clearfix" data-desktop={40} data-mobile={35} data-smobile={35} />
                                                        <TabProjectAcondicionamiento />
                                                        {/* <div className="button-wrap has-icon icon-left size-14 pf21 text-center">
                                                            <Link to="#" className="themesflat-button bg-accent pd32"><span>LOAD MORE <span className="icon"><i className="ion-load-c" /></span></span></Link>
                                                        </div>                                            */}
                                                        <div className="themesflat-spacer clearfix" data-desktop={72} data-mobile={60} data-smobile={60} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                        {
                            this.state.headers.map((data,idx) =>(
                                <BottomBar data={data} key={idx}/>
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectsAcondicionamiento;